import React, { useEffect, useState } from "react";
import {
  Typography,
  CircularProgress,
  Card,
  CardContent,
  Button,
  Grid2,
  Badge,
  Backdrop,
} from "@mui/material";
import Layout from "../components/Layout";
import { getAllCourses, getAllUpgradedLARForAdmin } from "../service/service";
import { Link } from "react-router-dom";

const ReviewUpgradedLAR = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [LARCounts, setLARCounts] = useState({});

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      try {
        const data = await getAllCourses();
        setCourses(data.data);
      } catch (error) {
        console.error("Failed to fetch courses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  // Fetch LAR counts and update the badge when courses change
  useEffect(() => {
    if (!courses.length) return;

    const fetchAllLARs = async () => {
      try {
        // Create an object mapping course IDs to their LAR counts
        const counts = Object.fromEntries(
          await Promise.all(
            courses.map(async (course) => [
              course._id,
              (await getAllUpgradedLARForAdmin(course._id, course.name)).length,
            ]),
          ),
        );
        setLARCounts(counts);
      } catch (error) {
        console.error("Failed to fetch LARs:", error);
      }
    };

    fetchAllLARs();
  }, [courses]);

  return (
    <Layout>
      {loading ? (
        <Backdrop open={loading} sx={{ zIndex: 1 }}>
          <CircularProgress />
        </Backdrop>
      ) : (
        <Grid2 container spacing={2}>
          {courses.map((course) => (
            <Grid2 item size={{ sx: 12, sm: 6, md: 4 }} key={course.id}>
              <Badge
                badgeContent={LARCounts[course._id] || 0}
                color="secondary"
                sx={{ width: "100%" }}
              >
                <Card sx={{ width: "100%" }}>
                  <CardContent>
                    <Typography variant="h5">{course.name}</Typography>
                    <Typography variant="body2">
                      {course.description}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      component={Link}
                      to={`/upgraded-lar/${course._id}/${course.name}`}
                      style={{ marginTop: "16px" }}
                    >
                      View Upgraded LAR
                    </Button>
                  </CardContent>
                </Card>
              </Badge>
            </Grid2>
          ))}
        </Grid2>
      )}
    </Layout>
  );
};

export default ReviewUpgradedLAR;
